import { render, staticRenderFns } from "./applicationPermission.vue?vue&type=template&id=1fab3da2&scoped=true"
import script from "./applicationPermission.vue?vue&type=script&lang=js"
export * from "./applicationPermission.vue?vue&type=script&lang=js"
import style0 from "./applicationPermission.vue?vue&type=style&index=0&id=1fab3da2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fab3da2",
  null
  
)

export default component.exports